import React, {CSSProperties, MouseEventHandler} from "react";
import styled, {css} from "styled-components";
import {PaddingSize} from "../../interface/css_interface";


export interface ButtonInterface extends ButtonStyleInterface {
    text: string,
    onClick?: MouseEventHandler,


}

interface ButtonStyleInterface {
    size?: PaddingSize,
    bgColor?: string,
    textColor?: string,
    textStyle?: CSSProperties,
    type?: 'color' | 'border',
    disable?: boolean


}

export const ButtonWidget: React.FC<ButtonInterface> = ({
                                                            size,
                                                            bgColor,
                                                            textColor,
                                                            textStyle,
                                                            text,
                                                            onClick,
                                                            type,
                                                            disable
                                                        }) => {
    return (
        <ButtonStyle propss={{size, bgColor, textColor, type, disable: disable || onClick == null}}
                     onClick={(ev) => {
                         ev.stopPropagation()
                         if (disable) return;
                         onClick&&onClick(ev)
                     }}
        >
            <p style={textStyle}>{text}</p>
        </ButtonStyle>
    );
}


const ButtonStyle = styled.div<{ propss: ButtonStyleInterface }>`
  border-radius: 100px;
  padding: ${({propss}) => propss.size ? propss.size.all ? `${propss.size.all}px` : `${propss.size.x}px ${propss.size.y}px` : '10px 10px'};
  box-sizing: border-box;
  background-color: ${({propss}) =>  propss.disable ? "#f3f3f3" :propss.bgColor || '#0064FD'};
  color: ${({propss}) => propss.textColor || '#FFFFFF'};
 
  display: inline-block;
  font-size: 16px;
  line-height: 1;
  cursor: ${({propss}) => propss.disable ? 'no-drop' : 'pointer'};
  ${({propss}) => {
    let {type} = propss;
    let _style;
    switch (type) {

      case 'border':
        _style = ButtonBorder;
        break;
      case 'color':
        _style = ButtonColor;
        break;
    }
    return _style;
  }};
`


const ButtonBorder = css<{ propss: ButtonStyleInterface }>`

  background: transparent;

  //border-image: linear-gradient(0deg, red, #203778) 10 10;
  border: 1px solid ${({propss}) => propss.bgColor || '#0064FD'};

  font-size: 14px;
  font-weight: 600;
  color: #2344EE;
`

const ButtonColor = css`
  font-size: 14px;
  font-weight: 600;
  background-color: #2344EE;
  border: 1px solid transparent;
  color: white;
`
